module.exports = __webpack_public_path__ + "static/pexels-photo-5077047-compressor-a7ab0e2793fb5eedb075774907b8cd94.jpeg";